import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons'
import { HStack, IconButton, Stack, Tooltip } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
// import PropTypes from 'prop-types'

import MFLogo from '../logo'
import MFEnvBadge from '../MFEnvBadge'

import { useMFNav } from './MFNav.Provider'

/**
 * MFNavSidebarHeader component to render the header of the sidebar navigation.
 *
 * @returns {JSX.Element} The sidebar header component.
 */
export default function MFNavSidebarHeader() {
  const {
    menu: { size, state },
    onClose
  } = useMFNav()

  const toggleIcon = useMemo(() => {
    if (size.value === 'dock') return <FontAwesomeIcon icon={byPrefixAndName['fak']['menu-layout-5line']} />
    if (size.value === 'full') return <FontAwesomeIcon icon={byPrefixAndName['fak']['menu-layout-2line']} />
    return <FontAwesomeIcon icon={byPrefixAndName['far']['xmark']} />
  }, [size])

  const toggleTooltipLabel = useMemo(() => {
    if (size.value === 'dock') return 'Expand'
    if (size.value === 'full') return 'Collapse'
    return 'Close'
  }, [size.value])

  const handleToggle = useCallback(() => {
    if (size.value === 'full') size.toggle('dock')
    else if (size.value === 'dock') size.toggle('full')
    else onClose()
  }, [size, onClose])

  const logoProps = useMemo(
    () => ({
      size: state.trueDockState ? 23.67 : 125,
      variant: state.trueDockState ? 'icon' : 'full'
    }),
    [state.trueDockState]
  )

  const badgeProps = useMemo(
    () => ({
      expanded: !state.trueDockState,
      fontSize: '3xs',
      position: 'absolute',
      bottom: -1,
      right: state.trueDockState ? '-50%' : 0,
      transform: `translateX(${state.trueDockState ? '-100%' : 0})`
    }),
    [state.trueDockState]
  )

  return (
    <HStack
      as="header"
      w="full"
      p="1.5"
      justifyContent={state.trueDockState ? 'center' : 'space-between'}
      alignItems="center"
    >
      <Stack as={Link} to="/dashboard" justifyContent="center" alignItems="center" h="8" position="relative" px="2">
        {/* <NavHeaderLogo menuState={state.trueDockState ? 'dock' : 'full'} skin={skin} /> */}
        <MFLogo {...logoProps} />
        <MFEnvBadge {...badgeProps} />
      </Stack>
      <Tooltip label={toggleTooltipLabel} placement="right" hasArrow>
        <IconButton
          hidden={state.trueDockState}
          aria-label="Toggle Sidebar"
          icon={toggleIcon}
          size="sm"
          variant="ghost"
          colorScheme="neutral"
          minW="auto"
          h="auto"
          onClick={handleToggle}
        />
      </Tooltip>
    </HStack>
  )
}
